import React, { FunctionComponent } from "react";
import { ResponsivePicture } from "@/components/responsive/product/responsivePicture/ResponsivePicture";

interface Props {
  image: string;
  alt: string;
  onClick?: React.MouseEventHandler<HTMLDivElement>;
  children?:React.ReactNode;
  isLazy?: boolean;
  className: string;
  openVideoPlayer: (index?: number) => void;
  isVideoIconDisplayed: boolean,
}

export const RenderImageThumbnail: FunctionComponent<Props> = ({
  image,
  alt,
  isLazy = true,
  onClick = () => { },
  className,
  isVideoIconDisplayed,
  openVideoPlayer,
  children,
}) => (
    <div className={className}>
      <div className="image">
        <ResponsivePicture url={image} alt={alt} isLazy={isLazy} onClick={onClick}/>
      </div>
      {isVideoIconDisplayed && (
          <div className="play-container" onClick={() => openVideoPlayer()}>
            <img className="play-button" src={"/assets/images/responsive/icons/playerIcon.svg"} alt='bouton player video'/>
          </div>
      )}
      {children}
    </div>
);
